import { ArcRotateCamera, AxesViewer, HemisphericLight, Scene } from "@babylonjs/core";
import "@babylonjs/core/Debug/debugLayer";
import { AdvancedDynamicTexture } from "@babylonjs/gui";
import "@babylonjs/inspector";
import JointSceneSettings from './joint-scene-settings';

export default class JointScene {
    readonly scene: Scene;
    readonly camera: ArcRotateCamera;
    readonly uiTexture = AdvancedDynamicTexture.CreateFullscreenUI("UI");
    private axes?: AxesViewer;

    constructor(scene: Scene) {
        this.scene = scene;

        this.camera = this.defaultArcRotateCamera();
        this.addHemisphericLight(scene);
    }

    clear = () => {
        [...this.scene.meshes].forEach(m => {
            m.dispose();
        });

        this.uiTexture.executeOnAllControls(c => {
            c.dispose();
        });
    }

    applySceneSettings = (newSettings: JointSceneSettings, prevSettings?: JointSceneSettings) => {
        const { scene } = this;
        if (!scene) return;

        if (newSettings.debug !== scene.debugLayer.isVisible()) {
            if (newSettings.debug) {
                scene.debugLayer.show({
                    embedMode: true,
                });
            } else {
                scene.debugLayer.hide();
            }
        }

        if (newSettings.axesScale !== this.axes?.scaleLines) {
            this.axes?.dispose();
            this.axes = new AxesViewer(this.scene, newSettings.axesScale);
        }

        if (newSettings.camera !== prevSettings?.camera) {
            Object.assign(this.camera, newSettings.currentCameraRotationSpecs);
        }
    }

    defaultArcRotateCamera(name: string = 'camera'): ArcRotateCamera {
        const dcs = JointSceneSettings.defaultArcRotateCameraSpecs;
        const camera = new ArcRotateCamera(name, dcs.alpha, dcs.beta, dcs.radius, dcs.target);
        camera.inputs.attachElement();
        camera.lowerRadiusLimit = dcs.lowerRadiusLimit;
        return camera;
    }

    addHemisphericLight(scene: Scene) {
        const hls = JointSceneSettings.defaultHemisphericLightSpecs;
        const light = new HemisphericLight("light1", hls.direction, scene);
        light.intensity = hls.intensity;
        light.diffuse = hls.diffuse;
        light.specular = hls.specular;
        light.groundColor = hls.groundColor;
        return light;
    }
}
